import type React from "react"
import { Box, Typography, Paper } from "@mui/material"

interface StepCardProps {
  icon: React.ReactNode
  title: string
  description: string
}

const StepCard: React.FC<StepCardProps> = ({ icon, title, description }) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 60,
          borderRadius: "50%",
          bgcolor: "primary.light",
          color: "white",
          mb: 2,
        }}
      >
        {icon}
      </Box>
      <Typography variant="h5" component="h3" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  )
}

export default StepCard
